
import Vue from "vue";
import { FormsAndSurveyServices } from "@/services";
import config from "@/config";
import { emitter, NotificationType } from "@/composables/emitter";
export default Vue.extend({
  data() {
    return {
      loadingPrebuiltSurveys: false,
      updateInProgress: false,
      prebuiltSurveysList: [] as any[],
      hasLoadedOnce: false,
      editingSurveyId: null as string | null,
    };
  },
  methods: {
    async getAllPrebuiltSurveys() {
      try {
        this.loadingPrebuiltSurveys = true;
        const { data } = await FormsAndSurveyServices.getPrebuiltSurveysList({
          locationId: config.prebuiltSurveyLocation,
        });
        this.prebuiltSurveysList = (data.themes || data.prebuiltSurveys || []).map((survey: any) => ({
          ...survey,
          editCategory: survey.category || '',
          editPriority: survey.priority || 1
        }));
        this.hasLoadedOnce = true;
        this.loadingPrebuiltSurveys = false;
      } catch (error) {
        console.log(error);
        this.prebuiltSurveysList = [];
        this.hasLoadedOnce = true;
        this.loadingPrebuiltSurveys = false;
      }
    },
    async updatePrebuiltSurvey(survey: any) {
      try {
        this.updateInProgress = true;
        this.editingSurveyId = survey._id;
        await FormsAndSurveyServices.updateThemes('surveys', survey._id, {
          category: survey.editCategory,
          priority: survey.editPriority
        });
        // Update the original values after successful update
        survey.category = survey.editCategory;
        survey.priority = survey.editPriority;
        this.updateInProgress = false;
        this.editingSurveyId = null;
        emitter.$emit("notification", {
          title: "Success",
          message: "Prebuilt survey updated successfully!",
          type: NotificationType.INFO,
        });
        // Refetch the prebuilt surveys to ensure data is in sync
        await this.getAllPrebuiltSurveys();
      } catch (error: any) {
        console.error(error);
        this.updateInProgress = false;
        this.editingSurveyId = null;
        emitter.$emit("notification", {
          title: "Update Failed",
          message: error.response?.data?.message || 'Failed to update prebuilt survey',
          type: NotificationType.ERROR,
        });
      }
    },
    isUpdateDisabled(survey: any): boolean {
      return this.updateInProgress || 
             (survey.category === survey.editCategory && survey.priority === survey.editPriority) ||
             !survey.editCategory;
    }
  },
});
